import { YEAR_REGEX } from '@monoimin/constants';

import { getYearForReplacement } from './getYearForReplacement';

export const replaceYearString = (string?: string | undefined) => {
  if (typeof string !== 'string') {
    return '';
  }
  //сперва заменяем [!year] на текущий год, а потом уже  старую регулярку используем чтобы не было так что первая замена затрагивает [!year] и в итоге мы получаем [2025] вместо 2025
  const replacedNew = injectCurrentYear(string);
  return replacedNew.replace(YEAR_REGEX, getYearForReplacement());
};
function injectCurrentYear(text: string): string {
  return text.replace(/\[!year\]/g, getYearForReplacement());
}
